import { RobinTheme, theme } from '@robinpowered/ui-kit';

type RobinExtendedToken = { [key: string]: unknown };

/**
 * `@robinpowered/ui-kit` exports an Ant Design theme config.
 * antd v6 enables css variables by default, so non-React styles (like `index.css`)
 * can consume tokens without extra config.
 */
export const robinTheme = { ...RobinTheme } as const;

/** Token shape from `theme.useToken()` — use for styled-component `$token` props. */
export type RobinThemeToken = ReturnType<typeof theme.useToken>['token'];

// ui-kit's `theme.d.ts` doesn't type some extended palette keys (e.g. `magenta1`, `purple1`),
// but they exist at runtime on `RobinTheme.token`.
export const robinToken = RobinTheme.token as RobinExtendedToken;
